/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The CampaignRunStartDates model module.
 * @module model/CampaignRunStartDates
 * @version 1.0.0
 */
export class CampaignRunStartDates {
  /**
   * Constructs a new <code>CampaignRunStartDates</code>.
   * @alias module:model/CampaignRunStartDates
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>CampaignRunStartDates</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CampaignRunStartDates} obj Optional instance to populate.
   * @return {module:model/CampaignRunStartDates} The populated <code>CampaignRunStartDates</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CampaignRunStartDates();
      if (data.hasOwnProperty('process'))
        obj.process = ApiClient.convertToType(data['process'], 'String');
      if (data.hasOwnProperty('run'))
        obj.run = ApiClient.convertToType(data['run'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} process
 */
CampaignRunStartDates.prototype.process = undefined;

/**
 * @member {String} run
 */
CampaignRunStartDates.prototype.run = undefined;

